<button
  [ngClass]="
    inProgress
      ? 'neptune-button-running'
      : disabled
        ? 'neptune-button-disabled'
        : 'neptune-button-blue'
  "
  [disabled]="disabled || inProgress"
  (click)="onClick()"
>
  <div class="flex items-center gap-2">
    <img *ngIf="iconUrl" [src]="iconUrl" alt="" class="icon" />
    <span>{{ label }}</span>
  </div>
</button>